import { createSelector } from 'reselect';
import type { FlipperFlagValues } from '../../../../../shared/ProductFlipperFlag.service';
import type { RootState } from 'client/js/redux';
import type { FlipperState } from './Flipper.types';

function getFeatureName(state: RootState, featureName: string): string {
  return featureName;
}

export function getFlipperState(state: RootState): FlipperState {
  return state.flipper_updates || {};
}

export const getFlipperFlagValues: (state: RootState) => FlipperFlagValues = createSelector(
  getFlipperState,
  (flipperState) => flipperState.features || {}
);

// TODO: Rename to isFlipperEnabled (in a new PR not to shadow the diff in the PR)
export const isFeatureEnabled: (state: RootState, featureName: string) => boolean = createSelector(
  getFlipperFlagValues,
  getFeatureName,
  (features, featureName) => Boolean(features[featureName])
);
